import offers from './offers'

const reducers = { offers }
export default reducers

export const defaultState = {
  offers: []
}
